import { TypographyVariantsOptions } from "@mui/material/styles";

const typography: TypographyVariantsOptions = {
  fontFamily: [
    "Inter",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  fontSize: 12,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontSize: "2rem",
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h2: {
    fontSize: "1.75rem",
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h3: {
    fontSize: "1.5rem",
    fontWeight: "600 !important",
    lineHeight: 1.25,
  },
  h4: {
    fontSize: "1.25rem",
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h5: {
    fontSize: "1rem",
    //fontSize: "16px !important",
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h6: {
    fontSize: 14,
    fontWeight: 900,
    lineHeight: 1.25,
  },
  body1: {
    fontSize: 14,
  },
  subtitle1: {
    fontSize: 14,
    lineHeight: 1.5,
  },
  button: {
    textTransform: "none",
    fontSize: 14,
    //fontSize: "0.85rem",
    //fontSize: "12px !important",
  },
};

export default typography;
